import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ClaudeDesktop } from '../claude-desktop/claude-desktop';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-chatgpt',
  imports: [RouterLink],
  templateUrl: './chatgpt.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './chatgpt.css'
})

export class ChatGPT extends ClaudeDesktop {

}